
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import { transactions, getPayChannel } from "@/model/trader/orderService";
import { payMessage, UpdateOrder } from "@/model/javaApi/detail.js";
import { paySystem, payType } from "@/utils/pay/parameter.js";
import mixinTxrNewWeb, { privateKeyMap } from "@/utils/mixin/mixinTxrNewWeb";
import { store } from "@/observable/store";
import { getAppClient } from "@/utils/commonUtils";
import { toApp } from "@/utils/appBridge.js";
import { get } from "lodash";

export default {
name: "detailPay",
mixins: [mixinTxrNewWeb],
data() {
return {
list: [],
load: false, // 防止多次点击
total_amount: 10, //总金额
deadlineTime: 1614843339, //订单过期时间戳
channelCommodityCode: "",
commodityName: "", // 商品名称
inlineDescList: [],
payChannel: "",
app_id: "",
orderClosed: false,
version: ''
};
},
computed: {
outTradeNo() {

return this.$route.query.outTradeNo;
},
baseNo() {

return this.$route.query.baseNo;
},

uid() {
return store.uid;
},
openid() {
return store.openid;
}
},
components: {
Cell,
Checker,
CheckerItem,
},
created() {
payMessage({ orderNo: this.outTradeNo, baseNo: this.baseNo }).then(
(res) => {
if (!res) return;
this.list = [
{ name: "商品信息:", value: res.productName || res.commodityName },
{ name: "订单编号:", value: res.orderNo },
{ name: "支付金额:", value: "¥" + res.payAmount },
];
this.total_amount = res.payAmount;
this.deadlineTime = res.deadlineTime;
this.channelCommodityCode = res.channelCommodityCode;
this.commodityName = res.commodityName;
this.orderClosed = res.closed;
this.$nextTick(() => {


const channelCommodityCode = get(res, "channelCommodityCode");
const productCode = get(res, "productCode");
this.payTX(
privateKeyMap[productCode] ? productCode : channelCommodityCode
);
});
}
);

getPayChannel({ system: parseInt(paySystem()) })
.then((res) => {
this.inlineDescList = res;
this.payChannel = this.inlineDescList[0].payChannel;
})
.catch((res) => {
this.$toast(res.message);
});
},
mounted() {
this.STATISTICS_CONFIG.insur_cashier_page();

toApp("getAppInfo", {})
.then((res) => {
this.app_id = res.app_id;
this.version = res.lver;
console.log("getAppInfo------", res);
})
.catch((error) => {

});
},
methods: {
async orderPrice() {
if (this.orderClosed) {
this.$toast("订单已失效，请重新投保！");
return;
}
this.$loading.show();
this.STATISTICS_CONFIG.insur_cashier_pay_click();
if (this.load) {
return false;
}
this.load = true;
setTimeout(() => {
this.load = false;
}, 1000);

let pay_system = parseInt(paySystem());
let url = `${window.location.origin}/detailPaySuccess?orderNo=${
this.outTradeNo
}&channelCommodityCode=${this.channelCommodityCode}&from_action=${store
.refid.item_id || ""}&ztItemId=${store.refid.zt_item_id}&activityId=${
store.refid.activity_id
}&TXbizKey=${store.TXoption.bizKey}&TXversion=${
store.TXoption.version
}&TXprivateKey=${encodeURIComponent(store.TXoption.privateKey)}&pid=${
store.refid.pid
}&ch=${store.refid.ch}`;
let parmer = {
trade_type: payType(), //支付类型
pay_channel: this.payChannel, //支付渠道
system: pay_system, //下单系统
user_mark: this.openid, // openid
app_id: this.app_id, // appid
out_trade_no: this.outTradeNo, //业务订单流水号
total_amount:
process.env.VUE_APP_CURRENTMODE === "production"
? this.total_amount * 100
: 1, //总金额
source: "insurance",
mch_name: "sybao",
subject: this.commodityName,
time_expire: this.deadlineTime, //过期时间
return_url: `${
window.location.origin
}/api/index?url=${encodeURIComponent(url)}`, //支付宝成功回调地址
};
console.log("支付参数", parmer);
let data = await this.tranSactions(parmer);
if (data.out_trade_no && data.trade_no && data.trade_id) {
let res = await this.updateOrder(
data.out_trade_no,
data.trade_no,
data.trade_id
);
if (res) {

this.goPay(data, {
channelCommodityCode: this.channelCommodityCode,
total_amount_yuan: this.total_amount,
...parmer,
});
}
}
},

tranSactions(parmer) {
return new Promise((resolve, reject) => {
transactions(parmer)
.then((res) => {
resolve(res);
})
.catch((res) => {
resolve({});
this.$toast(res.message);
})
.finally(() => {
this.$loading.hide();
});
});
},

updateOrder(orderNo, tradeNo, tradeId) {
return new Promise((resolve, reject) => {
UpdateOrder({ orderNo, tradeNo, tradeId })
.then((res) => {
resolve(res);
})
.catch((res) => {
resolve("");
this.$toast(res.msg);
});
});
},

goPay(data, postData) {
let channelCommodityCode = postData.channelCommodityCode;
let pay_type = postData.pay_channel == "wxpay" ? "3" : "1";
if (getAppClient() == "APP") {
const url = `${
window.location.origin
}/detailPaySuccess?flag=postdisable&orderNo=${
data.out_trade_no
}&tradeNo=${
data.trade_no
}&channelCommodityCode=${channelCommodityCode}&TXbizKey=${
store.TXoption.bizKey
}&TXversion=${store.TXoption.version}&TXprivateKey=${encodeURIComponent(
store.TXoption.privateKey
)}&pid=${store.refid.pid}&ch=${store.refid.ch}`;
let parme = {
pay_type: pay_type, // 支付宝 1 wx 3
app_success_url: `${
window.location.origin
}/api/index?sybao=boy&url=${encodeURIComponent(url)}`, //成功之后回掉
wx_info: {

prepayid: data.wechat ? data.wechat.prepay_id : "",
nonceStr: data.wechat ? data.wechat.nonce_str : "",
time_weixin_pay: data.wechat ? parseInt(data.wechat.timestamp) : "",
str_weixin: data.wechat ? data.wechat.pay_sign : "",
},
ali_info: {

expire_time: data.alipay ? data.alipay.time_expire : "",
order_id: data.alipay ? data.alipay.order_no : "",
price_deposit:
process.env.VUE_APP_CURRENTMODE === "production"
? postData.total_amount_yuan
: 0.01, //价格 元
title: data.alipay ? data.alipay.subject : "",
},
};
const appConfig = Object.assign({}, parme, data);
console.log("payparme---:", this.version);

function compareVersions(version1, version2) {
const v1 = version1.split('.').map(Number);
const v2 = version2.split('.').map(Number);
for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
const num1 = v1[i] || 0;
const num2 = v2[i] || 0;

if (num1 > num2) return 1;
if (num1 < num2) return -1;
}
return 0;
}
const comparisonResult = compareVersions(this.version, '9.64.0');
if(comparisonResult >= 0){
toApp('app_pay_channel',appConfig)
}else{

this.$toast(`请升级APP到最新版本`)
}
} else {
const _this = this;
if (getAppClient() == "MWEB") {

if (pay_type == 3) {

window.location.href = `${
data.wechat.mweb_url
}&redirect_url=${encodeURIComponent(
`${window.location.origin}/detailPaySuccess?tradeNo=${
data.trade_no
}&orderNo=${
data.out_trade_no
}&channelCommodityCode=${channelCommodityCode}&from_action=${
store.refid.item_id
}&ztItemId=${store.refid.zt_item_id}&activityId=${
store.refid.activity_id
}&TXbizKey=${store.TXoption.bizKey}&TXversion=${
store.TXoption.version
}&TXprivateKey=${encodeURIComponent(
store.TXoption.privateKey
)}&pid=${store.refid.pid}&ch=${store.refid.ch}`
)}`;
} else if (pay_type == 1) {

window.location.href = `${data.alipay.web_url}`;
}

return;
}
wx.ready(function() {

wx.chooseWXPay({
timestamp: data.wechat.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: data.wechat.nonce_str, // 支付签名随机串，不长于 32 位
package: data.wechat.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
signType: data.wechat.sign_type, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: data.wechat.pay_sign, // 支付签名
success: function(res) {
_this.$router.replace({
path: "/detailPaySuccess",
query: {
orderNo: data.out_trade_no,
tradeNo: data.trade_no,
channelCommodityCode: channelCommodityCode,
flag: "postdisable",
pid: store.refid.pid,
ch: store.refid.ch,
},
});
},
fail: function(res) {
console.log("res----", res);
},
cancel: function(res) {
console.log("支付验证err", res);
},
});
});
wx.error(function(res) {
console.log("微信初始化失败", res);
});
}
},
},
};
